// extracted by css-extract-rspack-plugin
export default {"editor":"DescriptionEditor-module__editor__dfegi"};